import { Link, LinkProps as MUILinkProps } from '@mui/material';
import { MouseEventHandler, ReactNode } from 'react';

interface ButtonLinkProps extends Omit<MUILinkProps<'button'>, 'component' | 'onClick'> {
    children: ReactNode;
    onClick: MouseEventHandler<HTMLButtonElement>;
    className?: string;
    tabIndex?: number;
}

const ButtonLink = ({
    variant = 'body2',
    underline = 'none',
    type = 'button',
    tabIndex = -1,
    ...props
}: ButtonLinkProps) => (
    <Link
        underline={underline}
        tabIndex={tabIndex}
        variant={variant}
        type={type}
        {...props}
        component="button"
    />
);

export { ButtonLink };
